import { useLocalStorage } from "usehooks-ts";

type AlertId = "check-mbf" | "submission-details";

export function useAlert(id: AlertId) {
  const [isAlertHidden, setIsAlertHidden] = useLocalStorage(id, false);

  return { hideAlert: () => setIsAlertHidden(true), isAlertHidden };
}
